module.exports = __webpack_public_path__ + "static/media/smarttelefon.5da77c81.mp3";